module.exports = __webpack_public_path__ + "static/feature_bg6-bb5b87c60ea0956d8bb30fda8919dcfe.png";